import { TASK_PRIORITY_LABELS } from "@/lib/tasks";

export function TaskPriorityIndicator({ priority }: { priority: number }) {
  const cls =
    priority >= 4
      ? "text-destructive font-semibold"
      : priority === 3
        ? "text-amber-600 font-medium"
        : "text-muted-foreground";
  return <span className={cls}>{TASK_PRIORITY_LABELS[priority] ?? "Normal"}</span>;
}
